import { DateTime } from "luxon";
import { FlueId } from "../FlueId";
import {
  FlueBurnMetricAggregateTimeUnit,
  flueBurnMetricAggregateTimeUnits,
} from "./FlueBurnMetricAggregateTimeUnit";

export interface FlueBurnMetricAggregateNaturalKey {
  flueId: FlueId;
  unit: FlueBurnMetricAggregateTimeUnit;
  time?: DateTime<true>;

  equals(other: FlueBurnMetricAggregateNaturalKey): boolean;
}

export class FlueBurnMetricAggregateNaturalKeyImpl
  implements FlueBurnMetricAggregateNaturalKey
{
  flueId: FlueId;
  unit: FlueBurnMetricAggregateTimeUnit;
  time?: DateTime<boolean> | undefined;

  constructor(
    flueId: FlueId,
    unit: FlueBurnMetricAggregateTimeUnit,
    time?: DateTime
  ) {
    this.flueId = flueId;
    this.unit = unit;
    this.time = time;
  }

  static ever = (flueId: FlueId): FlueBurnMetricAggregateNaturalKeyImpl =>
    new FlueBurnMetricAggregateNaturalKeyImpl(
      flueId,
      flueBurnMetricAggregateTimeUnits.ever
    );

  static sinceSweep = (
    flueId: FlueId,
    time: DateTime
  ): FlueBurnMetricAggregateNaturalKeyImpl =>
    new FlueBurnMetricAggregateNaturalKeyImpl(
      flueId,
      flueBurnMetricAggregateTimeUnits.sinceSweep,
      time
    );

  static year = (
    flueId: FlueId,
    time: DateTime<true> | number
  ): FlueBurnMetricAggregateNaturalKeyImpl =>
    new FlueBurnMetricAggregateNaturalKeyImpl(
      flueId,
      flueBurnMetricAggregateTimeUnits.year,
      typeof time === "number" ? DateTime.local(time) : time
    );

  static month = (
    flueId: FlueId,
    time: DateTime<true> | [number, number]
  ): FlueBurnMetricAggregateNaturalKeyImpl =>
    new FlueBurnMetricAggregateNaturalKeyImpl(
      flueId,
      flueBurnMetricAggregateTimeUnits.month,
      Array.isArray(time) ? DateTime.local(time[0], time[1]) : time
    );

  equals(other: FlueBurnMetricAggregateNaturalKey): boolean {
    if (this.flueId !== other.flueId) {
      return false;
    } else if (this.unit !== other.unit) {
      return false;
    } else if (this.unit === flueBurnMetricAggregateTimeUnits.ever) {
      return true;
    } else if (this.unit === flueBurnMetricAggregateTimeUnits.sinceSweep) {
      return true;
    } else if (
      this.unit === flueBurnMetricAggregateTimeUnits.atSensorOperational
    ) {
      return true;
    } else if (this.time != null && other.time != null) {
      return this.unit === other.unit && this.time.equals(other.time);
    } else {
      return false;
    }
  }
}
